import { fetcher } from "src/api/fetcher";
import { object, string, picklist, type InferInput } from "valibot";
import { UserProfile } from "../schema/UserProfile";

export async function createSession({
  token,
  authMethod,
  defaultUserProfile,
}: {
  token: string;
  authMethod: "google" | "apple" | "OneTimePassword";
  defaultUserProfile?: UpdateUserProfile;
}) {
  return await fetcher("/api/1.6/auth/session", {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      token,
      authMethod,
      defaultUserProfile,
    }),
    schema: CreateSessionResponse,
  });
}

export async function getSession() {
  return await fetcher("/api/1.6/auth/session", {
    method: "GET",
    credentials: "include",
    schema: GetSessionResponse,
  });
}

export async function deleteSession() {
  await fetcher("/api/1.6/auth/session", {
    method: "DELETE",
    credentials: "include",
  });
}

type UpdateUserProfile = {
  name?: string;
  profileCurrency?: string;
  isKilometers?: boolean;
  profileLanguage?: string;
  optedInMarketingEmails?: boolean;
  is24h?: boolean;
};

const CreateSessionResponse = object({
  sessionId: string(),
  user: UserProfile,
  action: picklist(["SignUp", "Login", "NewLoginMethod"]),
});

type GetSessionResponse = InferInput<typeof GetSessionResponse>;
const GetSessionResponse = object({
  sessionId: string(),
  user: UserProfile,
});
